import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const ImportFilesRoutes: Routes = [
  {
    path: "import-files",
    loadComponent: () =>
      import("./import-files/import-files.component").then(
        (m) => m.ImportFilesComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./import-files-list/import-files-list.component").then(
            (m) => m.ImportFilesListComponent,
          ),
      },
      {
        path: "add",
        loadComponent: () =>
          import("./import-files-form/import-files-form.component").then(
            (m) => m.ImportFilesFormComponent,
          ),
      },
    ],
  },
];
